<template>
  <div>

    <!-- we have commented this code behalf of jean's email. -->
    <!-- <h2 class="text-xs text-center font-semibold tracking-wide text-gray-500">Search By:</h2>
    <div class="relative mt-1.5 mb-5 flex justify-center">
      <div class="bg-gray-700 p-0.5 rounded-full flex">
        <button type="button" @click="setSearchBy('Situs_Address')"
          class="relative py-1.5 px-4 border border-transparent rounded-full text-xs font-semibold whitespace-nowrap focus:outline-none"
          :class="[searchBy == 'Situs_Address' ? 'bg-white text-gray-800' : 'text-gray-200 hover:bg-gray-800']">Property
          Address</button>
        <button type="button" @click="setSearchBy('Account_Num')"
          class="relative py-1.5 px-4 border border-transparent rounded-full text-xs font-semibold whitespace-nowrap focus:outline-none"
          :class="[searchBy == 'Account_Num' ? 'bg-white text-gray-800' : 'text-gray-200 hover:bg-gray-800']">Account
          Number</button>
      </div>
    </div> -->

    <!-- Search by  Situs Address -->
    <div v-if="searchBy == 'Situs_Address'">
      <div class="flex sm:flex-row flex-col items-center rounded-xl border border-gray-200 shadow-sm bg-white overflow-hidden focus-within:ring-2 focus-within:ring-gray-700 transition">
         <!-- County Select -->
        <select v-model="selectedCounty" @change="setCounty(selectedCounty)"
          class="appearance-none sm:w-40 w-full h-full text-white focus:border-transparent bg-gray-700 hover:bg-gray-800  border-transparent text-sm font-medium px-4 py-3 focus:outline-none cursor-pointer" style=" border-right: 1px solid #dde0e4; background-image: url('data:image/svg+xml;utf8,<svg fill=\'white\' height=\'20\' viewBox=\'0 0 20 20\' width=\'20\' xmlns=\'http://www.w3.org/2000/svg\'><path d=\'M5 7l5 5 5-5\'/></svg>');"> >
          <option value="tarrant">Tarrant County</option>
          <option value="denton">Denton County</option>
        </select>

        <div class="flex items-center flex-1 pr-3 w-full ">
          <!-- Icon -->
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5  text-gray-400 pl-2 flex-shrink-0"
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <v-select :getOptionLabel="propertyAddressLabel" :options="properties" :appendToBody=true
            :filter-by="() => true"  :filterable="false"  :dropdown-should-open="dropdownShouldOpen" @search="searchHandler" @input="setProperty"
            placeholder="Enter address of your property" class="vue-select">
            <!-- loader -->
            <template #no-options="{ search, searching, loading }">
              <i v-if="loading" class="fa fa-spinner fa-spin"></i>
              <div v-else>No matching property address found</div>
            </template>

            <!-- spinner -->
            <template #spinner="{ loading }">
              <i v-if="loading" class="fa fa-spinner fa-spin"></i>
            </template>

            <!-- Dropdown indicator -->
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"></span>
            </template>

            <!-- Options -->
            <template #option="option">
              {{ propertyAddressLabel(option) }}
            </template>
          </v-select>
        </div>
      </div>
    </div>

    <!-- Search by account number -->
    <div v-if="searchBy == 'Account_Num'">
      <div class="flex sm:flex-row flex-col items-center rounded-xl border border-gray-200 shadow-sm bg-white overflow-hidden focus-within:ring-2 focus-within:ring-gray-700 transition">
         <!-- County Select -->
        <select v-model="selectedCounty" @change="setCounty(selectedCounty)"
          class="appearance-none sm:w-40 w-full h-full text-white focus:border-transparent bg-gray-700 hover:bg-gray-800  border-transparent text-sm font-medium px-4 py-3 focus:outline-none cursor-pointer" style=" border-right: 1px solid #dde0e4; background-image: url('data:image/svg+xml;utf8,<svg fill=\'white\' height=\'20\' viewBox=\'0 0 20 20\' width=\'20\' xmlns=\'http://www.w3.org/2000/svg\'><path d=\'M5 7l5 5 5-5\'/></svg>');"> >
          <option value="tarrant">Tarrant County</option>
          <option value="denton">Denton County</option>
        </select>

        <!-- Input with Icon -->
        <div class="flex items-center flex-1 pr-3 w-full ">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 text-gray-400 pl-2 flex-shrink-0" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
            </svg>
          <v-the-mask :mask="accountNoMask" type="text" name="account_no" v-model="account_no" :masked=false
            :placeholder="accountNoPlaceholder" autocomplete="off"
            class="focus:outline-none focus:ring-0 focus:border-transparent flex-1 block w-full rounded-none rounded-r-md px-4 py-2.5 text-gray-800 font-medium placeholder-gray-400 border-transparent border-0 "
            style="line-height: 26px;" />>
        </div>
      </div>
    </div>

    <div class="text-red-600 text-sm text-left p-1 mb-2" v-if="errors.property" v-html="errors.property_message">
    </div>

    <div v-if="searchBy === 'Account_Num'" class="text-left my-1">
      <a class="text-gray-600 hover:text-gray-700 text-xs font-medium underline"
        href="https://www.youtube.com/watch?v=H7FzyNapOjg" target="_blank">
        <i class="fa fa-info-circle"></i> How to find your CAD account number?
      </a>
    </div>

    <div class="mt-4 text-center" v-if="this.searchBy">
      <button @click="submitHandler"
        class="shadow inline-block px-8 py-2.5 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        Does My Property Qualify?
      </button>
    </div>

    <registration-year-confirmation-modal v-if="isRegistrationYearConfirmationModalOpen"
      @confirm="confirmForNewYearShowingInterest" @email-submitted="saveEmailToWaitingList"
      @close="isRegistrationYearConfirmationModalOpen = false" />
  </div>
</template>

<script>
import { debounce } from 'lodash';
import ProtestRequestApi from "@/services/api/ProtestRequest.js";
import RegistrationYearConfirmationModal from "./Modal/RegistrationYearConfirmationModal.vue";
import WaitingList from "@/services/api/WaitingList.js";


export default {
  props: ["isRegistrationClosedOrFullyOpened", "intent"],
  components: {
    RegistrationYearConfirmationModal,
  },
  data() {
    return {
      account_no: null,
      property: null,
      properties: [],
      minlength: 1,
      searchBy: "Situs_Address",
      errors: {},
      isRegistrationYearConfirmationModalOpen: false,
      selectedCounty: 'denton'
    };
  },
  computed: {
    accountNoMask() {
      return this.selectedCounty === 'denton' ? 'XXXXXXXXXXXX' : 'XXXXXXXX';
    },
    accountNoPlaceholder() {
      return this.selectedCounty === 'denton'
        ? 'Enter your 12 digit CAD account number'
        : 'Enter your 8 digit CAD account number';
    },
  },
  methods: {
    setCounty(county) {
      this.selectedCounty = county;
      this.property = null;
      this.account_no = null;
      this.properties = [];
      this.errors = {};
    },

    setSearchBy(prop) {
      this.searchBy = prop;
      this.property = null;
      this.account_no = null;
      this.errors = {};
    },

    searchHandler: debounce(function(text, loading) {
      loading(true);

      ProtestRequestApi.getPropertySuggestions(this.searchBy, text, this.selectedCounty).then(
        (response) => {
          var properties = response.data.properties;
          this.properties = properties;

          loading(false);
        }
      );
    }, 300),

    dropdownShouldOpen(VueSelect) {
      if (this.property?.Account_Num) {
        return VueSelect.open;
      }

      return VueSelect.search.length !== 0 && VueSelect.open;
    },

    propertyAddressLabel(property) {
      return property.Situs_Address.trim() + " (#" + property.Account_Num + ")";
    },

    setProperty(value) {
      this.property = value;
      this.account_no = value?.Account_Num;
    },

    validateData() {
      var errors = {};
      var error = false;

      if (!this.account_no) {
        errors.property = true;
        errors.property_message = "Invalid search parameter";
        error = true;
      }

      const requiredLength = this.selectedCounty === 'denton' ? 12 : 8;
      if (this.account_no && this.account_no.length !== requiredLength) {
        errors.property = true;
        errors.property_message = `Your Account Number must be of ${requiredLength} digits`;
        error = true;
      }

      this.errors = errors;

      return error;
    },

    submitHandler() {
      if (this.validateData()) return;

      if (!this.isRegistrationClosedOrFullyOpened) {
        this.isRegistrationYearConfirmationModalOpen = true;
        return;
      }
      this.finalSubmit();

    },

    finalSubmit() {
      blockUI();

      ProtestRequestApi.search(this.account_no, this.selectedCounty, this.intent).then((response) => {
        unblockUI();

        if (response.data.error) {
          var errors = {};
          errors.property = true;
          errors.property_message =
            "<i class='fa fa-exclamation-triangle'></i> " +
            response.data.message;

          this.errors = errors;
          return;
        }
        window.location.href = response.data.redirect_to;
      });
    },
    cancleForNewYeaShowingInterest() {
      this.isRegistrationYearConfirmationModalOpen = false;
      //call waiting list

    },
    confirmForNewYearShowingInterest() {
      this.isRegistrationYearConfirmationModalOpen = false;
      this.finalSubmit();
    },

    saveEmailToWaitingList(form) {
      console.log(form);
      WaitingList.store(form)
        .then(() => {
          this.isRegistrationYearConfirmationModalOpen = false;
        })
        .catch(() => {
          alert('Failed to save email. Please try again.');
        });
    },
  },
};
</script>
